// eslint:disable no-use-before-declare
import { FavouriteRowValue, FavouriteDataColumn, AggregationType } from './favourite-interfaces';
import { DrillDownModel, DrillDownCallback, CaseViewCallback } from './drill-down-model';
import { FavouriteDataAdapter } from './favourite-data-adapter';

export class DrillDownHandler {
  private readonly drillDown: DrillDownCallback;
  private readonly caseView: CaseViewCallback;
  private readonly favouriteDataAdapter: FavouriteDataAdapter;

  constructor(drillDown: DrillDownCallback, caseView: CaseViewCallback, favouriteDataAdapter: FavouriteDataAdapter) {
    this.drillDown = drillDown;
    this.caseView = caseView;
    this.favouriteDataAdapter = favouriteDataAdapter;
  }

  public toCaseListing(rowIndex: number, skipColumns: number[] = []) {
    const aggrColumn = this.favouriteDataAdapter.dataModel.columns[this.favouriteDataAdapter.aggrColIndex];
    const outputReport = this.getOutputReport();
    const aggrValue = this.getAggregateValue(rowIndex, outputReport, aggrColumn);

    const modelBuilder = new DrillDownModelBuilder(outputReport)
      .withAggregationFilter(aggrColumn, aggrValue);

    for (let i = 0; i < this.favouriteDataAdapter.dataModel.columns.length; i++) {
      if (this.favouriteDataAdapter.dataModel.columns[i].columnType === 'selection' && skipColumns.indexOf(i) === -1) {
        modelBuilder.withFilter(this.favouriteDataAdapter.dataModel.columns[i], this.favouriteDataAdapter.dataModel.rows[rowIndex][i]);
      }
    }

    this.drillDown(this.favouriteDataAdapter.dataModel.id, modelBuilder.model());
  }

  private getAggregateValue(rowIndex: number, outputReport: number, aggrColumn: FavouriteDataColumn) {

    if (outputReport === 1 || outputReport === 2) { 
      if (rowIndex < 0)  {
        if (aggrColumn.aggregationType === AggregationType.Minimum) {
          return this.favouriteDataAdapter.columnExtremes[this.favouriteDataAdapter.aggrColIndex].min;
        }
        else if (aggrColumn.aggregationType === AggregationType.Maximum) {
          return this.favouriteDataAdapter.columnExtremes[this.favouriteDataAdapter.aggrColIndex].max;
        }
      }
    }
    
    return this.favouriteDataAdapter.dataModel.rows[rowIndex][this.favouriteDataAdapter.aggrColIndex];
  }

  private getOutputReport() {
    return null;
  }

  public toCaseListingWithAllCases() {

    this.drillDown(this.favouriteDataAdapter.dataModel.id, new DrillDownModelBuilder(this.getOutputReport()).model());
  }

  public toCaseView(rowIndex: number, colIndex: number) {

    const selectedRow = this.favouriteDataAdapter.dataModel.rows[rowIndex];

    return this.caseView(selectedRow[colIndex].value);
  }
}

export class DrillDownModelBuilder {
  private readonly drillDownModel: DrillDownModel;

  constructor(outputReport: number) {
    this.drillDownModel = {
      autoExecute: true,
      outputReport
    };
  }

  private validateSelectionColumn(column: FavouriteDataColumn): boolean {
    return column.columnType === 'selection';
  }

  public withAggregationFilter(aggregationColumn: FavouriteDataColumn, aggregationValue: FavouriteRowValue): DrillDownModelBuilder {
    this.drillDownModel.aggregationDomain = aggregationColumn.domain as number;
    this.drillDownModel.aggregationType = aggregationColumn.aggregationType;
    if (aggregationValue) {
      this.drillDownModel.aggregationValue = aggregationValue.value;
    }

    return this;
  }

  public withFilter(column: FavouriteDataColumn, columnValue: FavouriteRowValue): DrillDownModelBuilder {
    if (!this.validateSelectionColumn(column)) {
      //TODO: Log condition.
      return this;
    }

    if (!this.drillDownModel.filters) {
      this.drillDownModel.filters = [];
    }

    this.drillDownModel.filters.push(
      {
        domain: column.domain as number,
        flgExactCodeCondition: column.codetable && column.selectionType === 1,
        value: (column.codetable && column.codetable > 0) ? columnValue.code : columnValue.value,
        period: column.period
      }
    );

    return this;
  }

  public model(): DrillDownModel {
    return this.drillDownModel;
  }
}
